import React from 'react'
import Link from 'next/link'
import styled from '@emotion/styled'
import { gsColors as c } from '../../styles/Variables'

export const faqPageHref = (categorySlug, page) =>
  page <= 1 ? `/faq/category/${categorySlug}` : `/faq/category/${categorySlug}/page/${page}`

export const getPageItems = (currentPage, pageCount, siblings = 1) => {
  const pages = new Set([1, pageCount])
  for (let p = currentPage - siblings; p <= currentPage + siblings; p += 1) {
    if (p >= 1 && p <= pageCount) { pages.add(p) }
  }

  const sorted = [...pages].sort((a, b) => a - b)
  const items = []
  let previous = 0
  for (const page of sorted) {
    if (page - previous > 1) { items.push({ type: 'ellipsis', key: `ellipsis-${page}` }) }
    items.push({ type: 'page', page, key: `page-${page}` })
    previous = page
  }
  return items
}

const FaqPager = ({ categorySlug, currentPage, pageCount }) => {
  if (pageCount <= 1) { return null }

  const items = getPageItems(currentPage, pageCount)

  return (
    <PagerWrapper aria-label='FAQ pages'>
      {currentPage > 1 && (
        <Link className='pager-arrow' aria-label='Previous page' href={faqPageHref(categorySlug, currentPage - 1)}>
          <span aria-hidden='true'>←</span> Prev
        </Link>
      )}
      {items.map((item) => {
        if (item.type === 'ellipsis') {
          return <span key={item.key} className='pager-ellipsis' aria-hidden='true'>…</span>
        }
        return item.page === currentPage
          ? <span key={item.key} className='pager-page current' aria-current='page'>{item.page}</span>
          : <Link key={item.key} className='pager-page' href={faqPageHref(categorySlug, item.page)}>{item.page}</Link>
      })}
      {currentPage < pageCount && (
        <Link className='pager-arrow' aria-label='Next page' href={faqPageHref(categorySlug, currentPage + 1)}>
          Next <span aria-hidden='true'>→</span>
        </Link>
      )}
    </PagerWrapper>
  )
}

export default FaqPager

const PagerWrapper = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 0 0 0;
  font-family: Euclid;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.5px;

  .pager-page,
  .pager-arrow {
    color: ${c.darkGrey};
    text-decoration: none;
    min-width: 40px;
    height: 40px;
    padding: 0 12px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: ${c.cobalt};
    }

    &:focus-visible {
      outline: 2px solid ${c.cobalt};
      outline-offset: 2px;
    }
  }

  .pager-page.current {
    color: ${c.white};
    background-color: ${c.cobalt};
  }

  .pager-ellipsis {
    color: ${c.darkGrey};
    min-width: 24px;
    text-align: center;
    user-select: none;
  }
`
